import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { LoaderContext } from "../../contexts/LoaderContext";
import React from "react";

export default function BackdropLoader() {
  const { isLoading } = React.useContext(LoaderContext);
  return (
    <Backdrop
      sx={(theme) => ({
        color: "#fff",
        zIndex: 1000 + theme.zIndex.modal,
      })}
      open={isLoading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
